import styled from "styled-components";

export const FormContainer = styled.div`
  padding: 32px 0;
  .prev {
    margin-top: -44px;
    padding-right: 12px;
  }
  @media only screen and (max-width: 760px) {
    .prev {
      margin-top: -40px;
    }
  }
`;
